<template>
  <div>
    <audio id="job-audio" controls controlsList="nodownload">
      <source :src="file">
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
  export default {
    props: {
      file: {
        type: String,
        required: true,
      },
      desiredTime: {
        type: String,
        required: false,
        default: '0',
      },
    },
    watch: {
      desiredTime(newVal) {
        document.getElementById('job-audio').currentTime = newVal;
        document.getElementById('job-audio').play();
      },
    },
    mounted() {
      document.getElementById('job-audio').currentTime = this.desiredTime;
    },
  };
</script>

<style scoped>

</style>
